import { Button } from "@/components/ui/button";
import { mainNav } from "@/config/nav";
import { Menu, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router";

interface MobileDrawerProps {
  isLoggedIn: boolean;
}

export function MobileDrawer({ isLoggedIn }: MobileDrawerProps) {
  const [open, setOpen] = useState(false);
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        className="md:hidden"
        onClick={() => setOpen(!open)}
      >
        <Menu className="h-6 w-6" />
        <span className="sr-only">Toggle menu</span>
      </Button>
      <div
        ref={drawerRef}
        className={`fixed top-0 right-0 h-full w-[300px] bg-white shadow-lg z-10 transform transition-transform duration-300 bg-opacity-[0.98]  ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold">Menu</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <X className="h-6 w-6" />
          </Button>
        </div>
        <div className="flex flex-col space-y-4 mt-4 p-4">
          {mainNav.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => setOpen(false)}
              className="text-left text-sm font-medium hover:underline underline-offset-4"
            >
              {item.title}
            </Link>
          ))}
          <Button asChild>
            {!isLoggedIn ? (
              <Link to="/login">Get Started</Link>
            ) : (
              <Link to="/dashboard">Dashboard</Link>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
